import { useSnapshot } from 'valtio'
import { type ReactElement } from 'react'
import { handleBlur, handleChange } from '../utils'
import { CardAddFormFieldNamesEnum } from '../cardAddFormFieldNamesEnum'
import { cardAddProxy } from '../cardAddProxy'
import { countryCodes, usStates } from '../../../utils/addressUtils'
import { toTitleCase } from '../../../utils/formattingUtils'
import { StandardInput } from '../../ui/forms/StandardInput'

export function CardSectionSlideContents (): ReactElement {
  const {
    showStateError,
    showCityError,
    showFirstNameError,
    showLastNameError,
    showStreetAddressOneError,
    showPostalCodeError,
    showCountryCodeError,
    formErrors,
    formValues
  } = useSnapshot(cardAddProxy, { sync: true })

  return (
    <>

      <div className="text-xl mx-2 my-4">
        Step 1: Billing Address
      </div>

      <div className="flex justify-between">
        <StandardInput
          label="First Name"
          value={formValues.firstName || ''}
          onChange={handleChange(CardAddFormFieldNamesEnum.FirstName)}
          onBlur={handleBlur(CardAddFormFieldNamesEnum.FirstName)}
          showError={showFirstNameError}
          errorMessage={formErrors.firstName as string}
        />

        <StandardInput
          label="Last Name"
          value={formValues.lastName || ''}
          onChange={handleChange(CardAddFormFieldNamesEnum.LastName)}
          onBlur={handleBlur(CardAddFormFieldNamesEnum.LastName)}
          showError={showLastNameError}
          errorMessage={formErrors.lastName as string}
        />

      </div>

      <div className="flex ">

        <StandardInput
          label="Billing Address"
          placeholder="Address Line 1"
          value={formValues.streetAddressOne || ''}
          onChange={handleChange(CardAddFormFieldNamesEnum.StreetAddressOne)}
          onBlur={handleBlur(CardAddFormFieldNamesEnum.StreetAddressOne)}
          showError={showStreetAddressOneError}
          errorMessage={formErrors.streetAddressOne as string}
        />

      </div>

      <div className="flex ">
        <StandardInput
          placeholder="Address Line 2"
          value={formValues.streetAddressTwo || ''}
          onChange={handleChange(CardAddFormFieldNamesEnum.StreetAddressTwo)}
          onBlur={handleBlur(CardAddFormFieldNamesEnum.StreetAddressTwo)}
          errorMessage={formErrors.streetAddressTwo as string}
        />
      </div>

      <div className="flex">
        <StandardInput
          label="City"
          value={formValues.city || ''}
          onChange={handleChange(CardAddFormFieldNamesEnum.City)}
          onBlur={handleBlur(CardAddFormFieldNamesEnum.City)}
          showError={showCityError}
          errorMessage={formErrors.city as string}
        />
      </div>

      <div className="flex">
        <div className="flex flex-col w-full mx-2">
          <label>State</label>
          <div className="relative">
            <select
              className="pt-2 pb-1.5 pl-3 text-left w-full  border border-wpy-gray rounded-md"
              onChange={handleChange(CardAddFormFieldNamesEnum.State)}
              onBlur={handleBlur(CardAddFormFieldNamesEnum.State)}
              value={formValues.state || ''}
              required
            >
              <option value="" disabled>Choose State</option>
              {
                  usStates.map(s => (
                    <option key={s.name} value={s.abbreviation}>{toTitleCase(s.name)}</option>)
                  )
                }
            </select>
            {showStateError && (
              <div className="h-5 absolute left-0.5 top-1 text-lg text-red">❗</div>
            )}
          </div>
          <div className="h-6 text-sm text-red-500">{formErrors.state}</div>
        </div>

        <StandardInput
          label="Zip / Postal Code"
          value={formValues.postalCode || ''}
          onChange={handleChange(CardAddFormFieldNamesEnum.PostalCode)}
          onBlur={handleBlur(CardAddFormFieldNamesEnum.PostalCode)}
          showError={showPostalCodeError}
          errorMessage={formErrors.postalCode as string}
        />

      </div>

      <div className="flex">
        <div className="flex flex-col w-full mx-2">
          <label>Country</label>
          <div className="relative">
            <select
              className="py-2 pl-3 text-left w-full  border border-wpy-gray rounded-md"
              onChange={handleChange(CardAddFormFieldNamesEnum.CountryCode)}
              onBlur={handleBlur(CardAddFormFieldNamesEnum.CountryCode)}
              value={formValues.countryCode as string || ''}
              required
            >
              <option value="" disabled>Choose Country</option>
              {
                  countryCodes.map(s => (
                    <option key={s.name} value={s.abbreviation}>{toTitleCase(s.name)}</option>)
                  )
                }
            </select>
            {showCountryCodeError && (
              <div className="h-5 absolute left-2 top-1 text-lg text-red">❗</div>
            )}
          </div>
          <div className="h-6 text-sm text-red-500">{formErrors.countryCode}</div>
        </div>

      </div>
    </>
  )
}
